import { Context } from '@nuxt/types/app';

export default ({ store }: Context) => {
    store.dispatch('auth/init');
};
